import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { mode, toggle } = useTheme();
  const isDark = mode === "dark";

  return (
    <button
      onClick={toggle}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 7,
        background: isDark ? "#1a1d2a" : "#f2f2f0",
        border: `1px solid ${isDark ? "#252836" : "#e4e4e1"}`,
        borderRadius: 20,
        padding: "4px 10px 4px 6px",
        cursor: "pointer",
        fontFamily: "inherit",
        transition: "all 0.2s",
      }}
    >
      <div style={{ position: "relative", width: 28, height: 16, borderRadius: 8, background: isDark ? "#5b9cf6" : "#d4d4d0", transition: "background 0.2s", flexShrink: 0 }}>
        <div style={{ position: "absolute", top: 2, left: isDark ? 14 : 2, width: 12, height: 12, borderRadius: "50%", background: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.3)", transition: "left 0.2s" }} />
      </div>
      {/* Icon */}
      <span style={{ fontSize: 13, lineHeight: 1 }}>
        {isDark ? "🌙" : "☀️"}
      </span>
    </button>
  );
}
